export const F280 = {
    name: "F280",
    features: [
        {
            title: 'Heating Load Calculations',
            description: 'Residential heating loads are calculated according to the CSA F280-12 standard, including component properties, infiltration, mechanical ventilation, cold partitions and radiant floors.',
            image: require('@/assets/img/content/f280-heating.jpg'),
        },
        {
            title: 'Cooling Load Calculations',
            description: 'Full support for CSA F280-12 residential cooling loads including internal loads, infiltration and ventilation loads, automated orientation for maximum loads, and room CFM estimates.',
            image: require('@/assets/img/content/f280-cooling.jpg'),
        },
        {
            title: 'Infiltration Air Leakage Loads',
            description: 'Implementation of CSA F280-12 methods for infiltration loads based on shielding, building type and air tightness.',
            image: require('@/assets/img/content/f280-infiltration.jpg'),
        },
        {
            title: 'Clear and Concise Reports',
            description: 'HeatCAD and LoopCAD provide clear, easy to read reports to communicate your design work to clients, homeowners or inspectors. The available reports include:<ul><li>CSA Load Summary</li><li>CSA Load Details</li><li>Heating System Summary</li><li>Annex D Summary</li></ul>',
            image: require('@/assets/img/content/f280-reports.jpg'),
        },
    ]
}
